import { UploadOutlined } from '@ant-design/icons';
import TaggedTooltipButton, { TaggedTooltipButtonOwnProps } from '../TaggedTooltipButton';
import styles from './styles.module.less';

const TaggedUploadButton = (props:TaggedTooltipButtonOwnProps) => {
  return (
    <TaggedTooltipButton
      {...props}
      icon={<UploadOutlined />}
      className={styles['orange-btn']}
    />
  );
};

export default TaggedUploadButton;
